<template lang="html">
    <div id="evectiob_travel"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
<!--        <div>-->
<!--        <navBar v-if="title === '管理员'" :tags="tags" :title="title"-->
<!--                :subTitle="subTitle"-->
<!--                :btnAgree="managerOnOff"-->
<!--                :btnRefuse="managerOnOff"-->
<!--                :btnSubmit="managerOnOff"-->
<!--                :btnSave="true"-->
<!--                :btnBack="true"-->
<!--                @btnAgreeClick="btnAgreeClick" @btnRefuseClick="btnRefuseClick" @btnSubmitClick="btnSubmitClick" @btnSaveClick="btnSaveClick"  @btnBackClick="handleBackClick"/>-->
<!--        <navBar v-else :tags="tags" :title="title"-->
<!--                :subTitle="subTitle"-->
<!--                :btnAgree="staffOnOff"-->
<!--                :btnRefuse="staffOnOff"-->
<!--                :btnSubmit="staffOnOffSave"-->
<!--                :btnSave="staffOnOffSub"-->
<!--                :btnBack="true"-->
<!--                @btnAgreeClick="btnAgreeClick" @btnRefuseClick="btnRefuseClick" @btnSubmitClick="btnSubmitClick" @btnSaveClick="btnSaveClick"  @btnBackClick="handleBackClick"/>-->
<!--        </div>-->
        <navBar :tags="tags" :title="titleName"
                :subTitle="subTitle"
                :btnAgree="agreedOnOff"
                :btnRefuse="refusedOnOff"
                :btnSubmit="submitOnOff"
                :btnSave="saveOnOff"
                :btnBack="true"
                :btnDelete="deleteOnOff"
                @btnDeleteClick="btnDeleteClick"
                @btnAgreeClick="btnAgreeClick" @btnRefuseClick="btnRefuseClick" @btnSubmitClick="btnSubmitClick" @btnSaveClick="inputBtnSaveClick"  @btnBackClick="handleBackClick"/>
        <div v-if="status === 'INFO'" style="width: 70%;margin-top:10px;float: left;">
<!--            :validate-on-rule-change="false"-->

            <el-form :disabled="onOff"
                     label-width="120px" :model="form" :rules="infoRules" ref="infoForm">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="计划日期" prop="end_time">
                            <el-date-picker
                                    style="width: 98%;"
                                    v-model="dateRange"
                                    type="datetimerange"
                                    range-separator="至"
                                    format="yyyy-M-d HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
<!--                    <el-col>-->
<!--                        <el-form-item label="计划日期" prop="date">-->
<!--                            <el-date-picker-->
<!--                                    v-model="form.start_time"-->
<!--                                    type="datetime"-->
<!--                                    format="yyyy-M-d HH:mm"-->
<!--                                    value-format="yyyy-MM-dd HH:mm"-->
<!--                                    placeholder="选择日期"-->
<!--                                    style="width: 46%">-->
<!--                            </el-date-picker><span style="width: 4%;margin:0 1%;display: inline-block;-->
<!--                            text-align:center">至-->
<!--                        </span><el-date-picker-->
<!--                                    v-model="form.end_time"-->
<!--                                    type="datetime"-->
<!--                                    format="yyyy-M-d HH:mm"-->
<!--                                    value-format="yyyy-MM-dd HH:mm"-->
<!--                                    placeholder="选择日期"-->
<!--                                    @change="chooseTimeRange1"-->
<!--                                    style="width: 46%">-->
<!--                            </el-date-picker>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :span="24">
                        <el-form-item label="出差地点" prop="travel">
                            <el-select
                                    style="width: 32.5%"
                                    v-model="form.province_name"
                                    @change="choseProvince(form.province_name)"
                                    placeholder="省级地区" clearable>
                                <el-option
                                        v-for="item in options_province"
                                        :key="item.province_id"
                                        :label="item.province_name"
                                        :value="item.province_id">
                                </el-option>
                            </el-select>
<!--                            <span style="visibility: hidden;margin: 0 1%;display: inline-block;-->
<!--            width: 4%;text-align: center">至</span>-->
                            <el-select
                                style="width: 32.5%"
                                v-model="form.city_name"
                                @change="CjwFangfa"
                                placeholder="市级地区" clearable>
                            <el-option
                                    v-for="item in options_city"
                                    :key="item.city_id"
                                    :label="item.city_name"
                                    :value="item.city_id">
                            </el-option>
                        </el-select>
                            <el-select
                                    style="width: 32%"
                                    v-model="form.county_name"
                                    placeholder="区县地区" clearable>
                                <el-option
                                        v-for="item in options_county"
                                        :key="item.county_id"
                                        :label="item.county_name"
                                        :value="item.county_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
<!--                    <el-col>-->
<!--                        <el-form-item >-->
<!--                            <el-select-->
<!--                                    style="width: 46%"-->
<!--                                    v-model="form.county_name"-->
<!--                                    placeholder="区县地区" clearable>-->
<!--                                <el-option-->
<!--                                        v-for="item in options_county"-->
<!--                                        :key="item.county_id"-->
<!--                                        :label="item.county_name"-->
<!--                                        :value="item.county_id">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :span="24">
                        <el-form-item label="交通工具" prop="transportation">
                            <el-select v-model="form.transportation" placeholder="请选择出行方式" style="width: 98%;" clearable>
                                <el-option
                                        v-for="item in transportation"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="预估费用">
                            <el-input-number style="width: 98%" type="number" v-model="form.expense" controls-position="right" :min="0"
                                      placeholder="预估费用"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="出差事由">
                            <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入内容"
                                    v-model="form.reason"
                                    style="width: 98%;">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div style="width: 100%;">
                <ul v-for="(item,i) in form.check_list">
                    <span style="color: #bbbbbb;font-size: 12px">{{item.checkin_date}}</span>
                    <li v-for="(obj,j) in item.data" style="width: 100%;height: 50px;background: #fafafa;
                    margin-top:10px;border-radius: 6px;cursor: pointer" @click="checkInfo(obj)">
                        <div style="width: 55%;height: 50px;float: left">
                            <p style="color: #3998f7;line-height: 50px;margin:0 0 0 25px">{{obj.location_name}}</p>
                        </div>
                        <div style="width: 15%;height: 50px;float: left;text-align: right">
                            <span v-if="obj.retroactive === 'T'" src="" alt="" style="line-height: 50px;
                            margin-right:20px;color: red">手动签到</span>
                            <img v-else :src="gps" alt="" width="30" style="margin-top: 5px;margin-right: 20px">
                        </div>
                        <div style="width: 30%;float: right">
                            <p style="font-size: 12px;margin-top: 10px;" :style="{'color':obj.checkin_time ?
                            '#bbbbbb' : 'red' }">签入：{{obj.checkin_time |
                                filterIn_time}}</p>
                            <p style="font-size: 12px;margin: 0" :style="{'color':obj.checkout_time ?
                            '#bbbbbb' : 'red' }"
                            >签出：{{obj.checkout_time | filterOut_time}}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div v-else style="width: 70%;margin-top:10px;float: left;">
            <el-form label-width="120px" :model="addForm" :rules="rules" ref="addForm">
                <el-row>
                    <el-col>
                        <el-form-item label="计划日期" prop="end_time">
                            <el-date-picker
                                    style="width: 98%;"
                                    v-model="dateRangeAdd"
                                    type="datetimerange"
                                    range-separator="至"
                                    format="yyyy-M-d HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
<!--                    <el-col>-->
<!--                        <el-form-item label="计划日期" prop="date">-->
<!--                            <el-date-picker-->
<!--                                    v-model="addForm.start_time"-->
<!--                                    type="datetime"-->
<!--                                    format="yyyy-M-d HH:mm"-->
<!--                                    value-format="yyyy-MM-dd HH:mm"-->
<!--                                    placeholder="选择日期"-->
<!--                                    style="width: 46%">-->
<!--                            </el-date-picker><span style="width: 4%;margin:0 1%;display: inline-block;-->
<!--                            text-align:center">至-->
<!--                        </span><el-date-picker-->
<!--                                    v-model="addForm.end_time"-->
<!--                                    type="datetime"-->
<!--                                    format="yyyy-M-d HH:mm"-->
<!--                                    value-format="yyyy-MM-dd HH:mm"-->
<!--                                    placeholder="选择日期"-->
<!--                                    @change="chooseTimeRange2"-->
<!--                                    style="width: 46%">-->
<!--                            </el-date-picker>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col>
                        <el-form-item label="出差地点" prop="travel">
                            <el-select
                                    style="width: 32.5%"
                                    v-model="addForm.province_name"
                                    @change="choseProvince(addForm.province_name)"
                                    placeholder="省级地区" clearable>
                                <el-option
                                        v-for="item in options_province"
                                        :key="item.province_id"
                                        :label="item.province_name"
                                        :value="item.province_id">
                                </el-option>
                            </el-select>
<!--                            <span style="visibility: hidden;margin: 0 1%;display: inline-block;-->
<!--            width: 4%;text-align: center">至</span>-->
                            <el-select
                                    style="width: 32.5%"
                                    v-model="addForm.city_name"
                                    @change="CjwFangfa"
                                    placeholder="市级地区" clearable>
                                <el-option
                                        v-for="item in options_city"
                                        :key="item.city_id"
                                        :label="item.city_name"
                                        :value="item.city_id">
                                </el-option>
                            </el-select>
                            <el-select
                                    style="width: 32%"
                                    v-model="addForm.county_name"
                                    placeholder="区县地区" clearable>
                                <el-option
                                        v-for="item in options_county"
                                        :key="item.county_id"
                                        :label="item.county_name"
                                        :value="item.county_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
<!--                    <el-col>-->
<!--                        <el-form-item >-->
<!--                            <el-select-->
<!--                                    style="width: 46%"-->
<!--                                    v-model="addForm.county_name"-->
<!--                                    placeholder="区县地区" clearable>-->
<!--                                <el-option-->
<!--                                        v-for="item in options_county"-->
<!--                                        :key="item.county_id"-->
<!--                                        :label="item.county_name"-->
<!--                                        :value="item.county_id">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col>
                        <el-form-item label="交通工具" prop="transportation">
                            <el-select v-model="addForm.transportation" placeholder="请选择出行方式" style="width: 98%;" clearable>
                                <el-option
                                        v-for="item in transportation"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="预估费用">
                            <el-input-number style="width: 98%" type="number" v-model="addForm.expense" controls-position="right" :min="0"
                                      placeholder="预估费用"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="出差事由">
                            <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入内容"
                                    v-model="addForm.reason"
                                    style="width: 98%;">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!--        右侧留言-->
        <div v-if="status === 'INFO'"
             style="width: 27%;float: left;border:1px solid #DEDEDE;background: #F4F6F8;margin-top:10px;margin-left:2.8%;border-radius:8px;box-sizing: border-box;
             min-height: calc(100% - 115px);">
            <el-row>
                <el-button @click="openSavePlanModel"
                           :class="['iconfont', 'el-icon-edit-outline',]" size="small"
                           type="primary"
                           style="float:right; height: 32px;padding: 8px 10px;
                           margin-top: 10px;margin-right: 10px;">
                    <i></i>写一笔</el-button>
            </el-row>

            <el-row style="overflow: auto">
                <el-col v-for="(item,j) in form.psArray" style="padding: 5%;">
                    <div style="width: 30px;height: 30px;float: left;overflow: hidden;border-radius: 100%;
                            position: relative">
                        <img v-if="item.src" :src="item.src"
                             width="100%"
                             alt="" style=" position: absolute;
                                        top:50%;
                                        left:50%;
                                        transform: translate(-50%,-50%);">
                    </div>
                    <div style="float:right;width: calc(100% - 50px)">
                        <p style="margin-top:0%;margin-bottom:0%;color: #4D586D;font-size: 12px">{{item.last_name}}</p>
                        <p :class="['iconfont','el-icon-time',]"
                           style="color: #87909A;margin-top:5px;margin-bottom:0%;font-size: 12px;"><i></i>{{
                            item.timestamp | componentFliter}}</p>
                        <p style="white-space:normal;
                        margin-top:10px;margin-bottom:5%;
                        word-break:break-all;overflow:hidden;
                        width:90%;color: #4A4A4A;font-size: 13px;line-height: 20px">{{item.contents.comments}}</p>
                    </div>
                </el-col>

            </el-row>
        </div>
        <el-dialog
                id="travelSavePlanPs"
                :visible.sync="modelSavePlanPs"
                :show-close="false"
                :before-close="handleClose"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">写一笔
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="savePlanPs()">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="modelSavePlanPs = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 20px">
                <el-input type="textarea" v-model="contents"> </el-input>

            </div>
        </el-dialog>
    </div>
</template>

<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import tou from '../../../assets/images/tou.png'
    import gps from '../../../assets/images/GPS.png'
    import {bus} from '../../../router/index'
    import moment from 'moment'
    export default {
        name: "travel",
        data() {
            const validateTime=(rule,value,callback)=>{
               if(this.addForm.start_time===""||this.addForm.end_time==="") {
                   callback(new Error('计划时间不能为空'))
               }else {
                   callback()
               }
            }
            const validateTravel=(rule,value,callback)=>{
                if(this.addForm.province_name===""||this.addForm.city_name==="") {
                    callback(new Error('出差地点不能为空'))
                }else {
                    callback()
                }
            }
            const infoValidateTime=(rule,value,callback)=>{
                console.log(this.form)
                if(!this.form.start_time || !this.form.end_time) {
                    callback(new Error('计划时间不能为空'))
                }else {
                    callback()
                }
            }
            const infoValidateTravel=(rule,value,callback)=>{
                if(!this.form.province_name||!this.form.city_name) {
                    callback(new Error('出差地点不能为空'))
                }else {
                    callback()
                }
            }
            return {
                id: "",
                loading: false,
                tags: ['日程安排','差旅计划'],
                titleName: this.$store.getters.getUser.alias,
                title:this.$store.getters.getUser.role ==='staff' ? this.$store.getters.getUser.alias:'管理员',
                subTitle: '',
                data:{},
                status:'',
                datePlan:'',
                form:{
                    activity_id:'',
                    reason:'',
                    expense:'',
                    start_time:'',
                    end_time:'',
                    transportation:'',
                    province_name:'',
                    city_name:'',
                    county_name:"",
                },
                transportation:[
                    {
                    label:'火车',
                    value:'RAILWAY'
                    },
                    {
                    label:'汽车',
                    value:'AUTOMOTIVE'
                    },
                    {
                    label:'飞机',
                    value:'AVIATION'
                    },
                    {
                     label:'船舶',
                      value:'MARINE'
                    },
                ],
                dateRange:[],
                modelSavePlanPs:false,
                options_province:[],
                options_city:[],
                province_name:'',
                city_name:'',
                addForm:{
                    activity_id:'',
                    reason:'',
                    expense:'',
                    start_time:'',
                    end_time:'',
                    transportation:'',
                    province_name:'',
                    city_name:'',
                    county_name:""
                },
                dateRangeAdd:[],
                contents:'',
                onOff:false,
                managerOnOff:false,
                staffOnOff:false,
                staffOnOffSub:false,
                staffOnOffSave:false,
                managerOnOff1:false,
                agreedOnOff:false,
                refusedOnOff:false,
                submitOnOff:false,
                saveOnOff:false,
                deleteOnOff:false,
                gps:gps,
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                rules:{
                    date:[{required:true,validator:validateTime,trigger:'blur'}],
                    travel:[{required:true,validator:validateTravel,trigger:'change'}],
                    transportation:[{required:true,message:'交通工具不能为空'}],
                    end_time:[{required:true,message:'计划时间不能为空',trigger:'change'}]
                },
                infoRules:{
                    // date:[{required:true,validator:infoValidateTime,trigger:'change'}],
                     travel:[{required:true,validator:infoValidateTravel,trigger:'change'}],
                      transportation:[{required:true,message:'交通工具不能为空'}],
                     end_time:[{required:true,message:'计划时间不能为空',trigger:'change'}]
                },
                writeOnOff:true,
                city_id:"",
                options_county:[]
            }
        },
        components: {
            navBar,
            // Upload
        },
        watch:{
            dateRange:{
                handler(nv,ol){
                    if (nv && nv.length >0){
                        this.form.start_time = nv[0]
                        this.form.end_time = nv[1]
                    }else {
                        this.form.start_time = ""
                        this.form.end_time = ""
                    }

                },
                deep:true
            },
            dateRangeAdd:{
                handler(nv,ol){
                    if (nv && nv.length >0){
                        this.addForm.start_time = nv[0]
                        this.addForm.end_time = nv[1]
                    }else {
                        this.addForm.start_time = ""
                        this.addForm.end_time = ""
                    }

                },
                deep:true
            }
        },
        filters:{
            componentFliter:function (value) {

                return moment(value).format('YYYY-M-D HH:mm:ss')
            },
            filterIn_time:function (value) {
                if (value) {
                    return moment(value).format('YYYY-M-D HH:mm:ss')
                }else {
                    return '尚未签入'
                }
            },
            filterOut_time:function (value) {
                if (value) {
                    return moment(value).format('YYYY-M-D HH:mm:ss')
                }else {
                    return '尚未签出'
                }
            }
        },
        mounted() {
            if (this.$store.getters.getUser.role === "staff") {
                this.managerOnOff1 = false
            }else {
                this.managerOnOff1 = true
            }
            if (this.managerOnOff1 === true) {
                this.agreedOnOff=false
                this.refusedOnOff=false
                this.submitOnOff=false
                this.saveOnOff=false
                this.deleteOnOff = false
            }else {
                this.agreedOnOff=false
                this.refusedOnOff=false
                this.submitOnOff=false
                this.saveOnOff=false
            }
            // document.getElementById('main').scrollTo(0, 0);
            this.getCityData('province')
            if(this.$route.params.type === 'new'){
                this.status = 'NEW'
                this.data = {}
                this.datePlan = ''
                this.subTitle = '创建差旅计划'
                if (this.managerOnOff1 === true){
                    this.agreedOnOff=false
                    this.refusedOnOff=false
                    this.saveOnOff=true
                    this.submitOnOff=true
                } else {
                    this.submitOnOff=true
                    this.saveOnOff=true
                }

            }else if (Object.keys(this.$route.params).length === 0){
                let condition = localStorage.getItem('condition')
                this.status = 'INFO'
                this.data = JSON.parse(condition)

                this.datePlan = this.data.start_time + ' - ' + this.data.end_time
                this.subTitle = this.data.start_time + ' - ' + this.data.end_time
                this.titleName = this.data.titleName
                this.init()
            } else {
                this.page = this.$route.params.page
                this.status = 'INFO'
                this.data = this.$route.params
                this.datePlan = this.data.start_time + ' - ' + this.data.end_time
                this.subTitle = this.data.start_time + ' - ' + this.data.end_time
                this.titleName = this.data.titleName
                this.init()
            }
        },
        methods: {
            CjwFangfa(value){
                this.city_id=value
                this.form.county_name = ''
                this.addForm.county_name = ''
                this.getCountyList()

            },
            async getCountyList(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    city_id: this.city_id
                }

                data.tenant_id = this.$store.getters.getUser.tenant_id
                await http.post('/wapi/Evection/getCountyList',data).then(res=>{
                    if (res.success == true){
                            this.options_county = res.data
                    }

                })
            },

            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        activity_id : this.data.activity_id,
                        owner_id : this.data.created_by
                    }
                    await http.post('/wapi/Evection/getTravePlanInfo',data).then(res=>{
                        if (res.success === true){
                            this.form = res.data
                            this.form.province_name = res.data.province_id
                            this.form.city_name = res.data.city_id
                            this.dateRange= [this.form.start_time,this.form.end_time]
                            this.subTitle =moment(res.data.start_time).format('YYYY年M月D日')  + ' - ' +
                                moment(res.data.end_time).format('M月D日')

                            if (this.managerOnOff1 === true){
                                if (this.form.created_by !== this.$store.getters.getUser.user_id) {
                                    if (this.form.status === 'APPROVED' || this.form.status === 'DENIED' ) {
                                        this.agreedOnOff=false
                                        this.refusedOnOff=false
                                        this.onOff = true
                                    }else {
                                        this.agreedOnOff=true
                                        this.refusedOnOff=true
                                        this.onOff = true
                                    }

                                }else { //是自己创建
                                    this.agreedOnOff = false    //隐藏同意按钮
                                    this.refusedOnOff = false   //隐藏拒绝按钮
                                    if (this.form.status === 'SUBMITTED' || this.form.status === 'APPROVED'){
                                        this.saveOnOff = false
                                        this.deleteOnOff = false
                                        this.onOff = true
                                        this.submitOnOff = false
                                    }else {
                                        this.saveOnOff = true
                                        this.deleteOnOff = true
                                        this.onOff = false
                                        this.submitOnOff = true
                                    }
                                }
                            }


                            if (this.form.status === 'SUBMITTED' || this.form.status === 'APPROVED'){
                                if (this.managerOnOff1 === false){
                                    this.deleteOnOff = false
                                    this.submitOnOff=false
                                    this.saveOnOff=false
                                    this.onOff = true
                                }
                            }else {
                                if (this.managerOnOff1 === false){
                                    this.submitOnOff=true
                                    this.saveOnOff=true
                                    this.onOff = false
                                    this.deleteOnOff = true
                                }
                            }
                            if(res.data.isClosed=='T'){
                                this.onOff=true
                                this.submitOnOff=false
                                this.saveOnOff=false
                                this.deleteOnOff=false
                                this.agreedOnOff=false
                                this.refusedOnOff=false
                                this.writeOnOff=false
                            }
                            loading.close()
                            this.getCityData(this.form.province_name)

                            //获取头像图片
                            for (let j=0;j<this.form.psArray.length;j++){
                                if (this.form.psArray[j].photo_id){
                                    this.getImgUrl(this.form.psArray[j])
                                }else {
                                    this.form.psArray[j].src = tou
                                }
                            }

                            //签到信息分组
                            let arr = this.form.check_list
                            var map = {},
                                dest = [];
                            for(var i = 0; i < arr.length; i++){
                                var ai = arr[i];
                                if(!map[ai.checkin_date]){　　//id 依赖字段 可自行更改
                                    dest.push({
                                        checkin_date: moment(ai.checkin_date).format('YYYY-M-D'), //id  依赖字段 可自行更改
                                        data: [ai]
                                    });
                                    map[ai.checkin_date] = ai;
                                }else{
                                    for(var j = 0; j < dest.length; j++){
                                        var dj = dest[j];
                                        if(dj.checkin_date == ai.checkin_date){ //id 依赖字段 可自行更改
                                            dj.data.push(ai);
                                            break;
                                        }
                                    }
                                }
                            }
                            this.form.check_list = dest
                            this.judeg(this.form.check_list)
                        }


                    })

                }catch (e) {
                    loading.close()
                }
            },
            judeg(arr){

                for (let j=0;j<arr.length;j++){
                    let array = arr[j].data
                    array.forEach((item,i)=>{
                        item.activity_date= moment(item.activity_date).format('YYYY年M月D日')
                        if (item.checkin_time) {
                            item.checkin_time_text = moment(item.checkin_time).format('YYYY年M月D日 HH:mm:ss')
                        }else {
                            item.checkin_time_text = '尚未签入'
                        }
                        if (item.checkout_time) {
                            item.checkout_time_text = moment(item.checkout_time).format('YYYY年M月D日 HH:mm:ss')
                        }else {
                            item.checkout_time_text = '尚未签出'
                        }
                        if (item.retroactive === "T"){
                            item.retroactive_text = '手动'
                        } else {
                            item.retroactive_text = 'GPS'
                        }

                    })
                }
                // this.tableData = array
            },
            handleBackClick(){
                this.$router.go(-1)
                bus.$emit('evection_page',this.page)
            },
            async getCityData(type){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    type : type,
                    province_id: type
                }

                data.tenant_id = this.$store.getters.getUser.tenant_id
                await http.post('/wapi/Evection/getProvinceList',data).then(res=>{
                    if (res.success == true){
                        if (data.type === 'province') {
                            this.options_province = res.data
                        }else {
                            this.options_city = res.data
                        }
                    }

                })
            },
            choseProvince(province_name){
                this.form.city_name = ''
                this.form.county_name = ''
                this.addForm.city_name = ''
                this.addForm.county_name = ''
                this.getCityData(province_name)
            },
            inputBtnSaveClick(){
                if (this.status === 'INFO'){
                    this.$refs["infoForm"].validate(valid=> {
                        if (!valid) {
                            return false
                        } else {
                            this.btnSaveClick()
                        }
                    })
                }else {
                    this.$refs["addForm"].validate(valid=> {
                        if (!valid) {
                            return false
                        } else {
                            this.btnSaveClick()
                        }
                    })
                }

            },
           async btnSaveClick(type){
               let loading = this.$loading({
                   lock: true,
                   text: '拼命加载中',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
               });
                try {
                    let data={}
                    if (this.status === 'INFO'){
                         data=this.form
                    } else {
                         data=this.addForm
                    }
                    if (!(data.start_time && data.end_time)){
                        this.$message({
                            type:'error',
                            message: '请选择时间'
                        })
                        loading.close()
                        return false;
                    }
                    if (!(data.province_name && data.city_name)){
                        this.$message({
                            type:'error',
                            message: '请选择出差地点'
                        })
                        loading.close()
                        return false;
                    }
                    if (!(data.transportation)){
                        this.$message({
                            type:'error',
                            message: '请选择交通工具'
                        })
                        loading.close()
                        return false;
                    }
                    data.tenant_id =this.$store.getters.getUser.tenant_id
                    data.user_id =this.$store.getters.getUser.user_id
                    await http.post('/wapi/Evection/saveTravelInfo',data).then(res=>{
                        if (res.success === true){

                            if (this.status === 'NEW'){
                                this.data.activity_id = res.data[0].activity_id
                                this.status = 'INFO'
                                this.addForm={
                                        reason:'',
                                        expense:'',
                                        start_time:'',
                                        end_time:'',
                                        transportation:'',
                                        province_name:'',
                                        city_name:''
                                }
                            }
                            if (type === 'submit'){
                                let obj={
                                    tenant_id : this.$store.getters.getUser.tenant_id,
                                    status : 'SUBMITTED',
                                    user_id : this.$store.getters.getUser.user_id,
                                    activity_id: this.data.activity_id
                                }

                                http.post('/wapi/Evection/submitTravelPlan',obj).then(res=>{
                                    if (res.success === true){
                                        //this.init()
                                        this.$message({
                                            type:'success',
                                            message:'提交成功'
                                        })
                                        loading.close()
                                        this.$router.push({
                                            name:'evection'
                                        })
                                    }

                                })
                            }else {
                                //this.init()
                                this.$message({
                                    type:'success',
                                    message: '保存成功'
                                })
                                loading.close()
                                this.$router.push({
                                    name:'evection'
                                })
                            }
                        } else {
                            this.$message({
                                type:'error',
                                message: res.message
                            })
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }
            },
            async btnDeleteClick(){
                this.$confirm('确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        let data=this.form
                        data.tenant_id =this.$store.getters.getUser.tenant_id
                        data.user_id =this.$store.getters.getUser.user_id
                        await http.post('/wapi/Evection/deleteTravel',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type:'success',
                                    message:'删除成功'
                                })
                                this.$router.go(-1)
                            }
                        })
                    }catch (e) {

                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
           async savePlanPs(){
               let loading = this.$loading({
                   lock: true,
                   text: '拼命加载中',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
               });
                try {
                    let data={
                        type:'TRAVEL',
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        id:this.form.activity_id,
                        user_id : this.$store.getters.getUser.user_id,
                        contents:{
                            comments:this.contents,
                            photos:[]
                        }
                    }
                    await http.post('/wapi/Evection/savePlanPs',data).then(res=>{
                        if (res.success === true){
                            this.init()
                            this.$message({
                                type:'success',
                                message:'保存成功'
                            })
                            this.modelSavePlanPs= false
                            this.contents = ''
                            loading.close()
                        }

                    })
                } catch (e) {
                    loading.close()
                }

            },
            openSavePlanModel(){
                this.modelSavePlanPs= true
            },
           async btnSubmitClick(){
               let loading = this.$loading({
                   lock: true,
                   text: '拼命加载中',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
               });
                try {
                    let data={
                        tenant_id : this.$store.getters.getUser.tenant_id,
                        status : 'SUBMITTED',
                        user_id : this.$store.getters.getUser.user_id,
                        activity_id: this.form.activity_id
                    }
                    if (!(this.form.start_time || this.addForm.start_time)){
                        this.$message({
                            type:'error',
                            message: '请选择日期'
                        })
                        loading.close()
                        return false;
                    }
                    if (!(this.form.end_time || this.addForm.end_time)){
                        this.$message({
                            type:'error',
                            message: '请选择日期'
                        })
                        loading.close()
                        return false;
                    }
                    if (!(this.form.province_name || this.addForm.province_name)){
                        this.$message({
                            type:'error',
                            message: '请选择省份'
                        })
                        loading.close()
                        return false;
                    }
                    if (!(this.form.city_name || this.addForm.city_name)){
                        this.$message({
                            type:'error',
                            message: '请选择城市'
                        })
                        loading.close()
                        return false;
                    }
                    if (!(this.form.transportation || this.addForm.transportation)){
                        this.$message({
                            type:'error',
                            message: '请选择交通工具'
                        })
                        loading.close()
                        return false;
                    }
                    if (this.form.activity_id){
                        await http.post('/wapi/Evection/submitTravelPlan',data).then(res=>{
                            if (res.success === true){
                                //this.init()
                                this.$message({
                                    type:'success',
                                    message:'提交成功'
                                })
                                this.$router.push({
                                    name:'evection'
                                })

                            }

                        })
                    } else {
                        this.btnSaveClick('submit')
                    }

                }catch (e) {
                    loading.close()
                }
            },
            async btnAgreeClick(){
                try {
                    let data={
                        status:'APPROVED',
                        user_id:this.$store.getters.getUser.user_id,
                        activity_id:this.form.activity_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/Evection/submitTravelPlan',data).then(res=>{
                        if (res.success === true){
                            // console.log(res)
                            this.$message({
                                type:'success',
                                message:'批准成功'
                            })
                            //this.init()
                            this.$router.push({
                                name:'evection'
                            })
                        }
                    })

                }catch (e) {

                }
            },
            async btnRefuseClick(){
                try {
                    let data={
                        status:'DENIED',
                        user_id:this.$store.getters.getUser.user_id,
                        activity_id:this.form.activity_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/Evection/submitTravelPlan',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type:'success',
                                message:'批准成功'
                            })
                            //this.init()
                            this.$router.push({
                                name:'evection'
                            })
                        }

                    })
                }catch (e) {

                }
            },
            chooseTimeRange1(t){
                let time1 = moment(t).valueOf()
                let time2 = moment(this.form.start_time).valueOf()
                if (time1<=time2){
                    this.$message({
                        type:"warning",
                        message:"结束时间应晚于开始时间"
                    })
                    this.form.end_time = ''
                }
            },
            chooseTimeRange2(t){
                let time1 = moment(t).valueOf()
                let time2 = moment(this.addForm.start_time).valueOf()
                if (time1<=time2){

                    this.$message({
                        type:"warning",
                        message:"结束时间应晚于开始时间"
                    })
                    this.addForm.end_time = ''
                }
            },
            // 获取图片id
            async getImgUrl(obj) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: obj.photo_id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data


                    if (array.length > 0) {
                        obj.src = array[0].thu_url
                        this.$forceUpdate()
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            checkInfo(row){
                this.$router.push({name:'jurisdictionInfo',params:row})
            },
            handleClose(){

            }
        },
    }
</script>

<style scoped>
    /*#container {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #evectiob_travel{
        height: 100%;
    }
    #evectiob_travel >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }
    #evectiob_travel >>>.el-table_1_column_7{
        color: #3b99f7;
    }
    #evectiob_travel >>>.el-table th{
        padding: 7px 0px;
    }
    #evectiob_travel >>>.el-table td{
        padding: 7px 0px;
    }
    #evectiob_travel >>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
        float: right;
    }
    #evectiob_travel >>> .el-button--warning {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    #evectiob_travel >>> .el-button--warning:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    #evectiob_travel >>> .el-icon-edit-outline:before{
        margin-right: 5px;
    }
    #evectiob_travel >>> .el-icon-time:before{
        margin-right: 5px;
    }
    #evectiob_travel >>> .el-input__inner::placeholder{
        text-align: left;
    }
    #evectiob_travel >>> .el-input-number.is-controls-right .el-input__inner {
        text-align: left;
    }
    #evectiob_travel >>>.el-icon-edit-outline:before {
        font-size: 16px;
    }
    #evectiob_travel >>>.el-icon-edit-outline span{
        position: relative;
        top: -2px;
        font-size: 13px;
    }
    #evectiob_travel >>> .el-range-editor .el-range-input{
        width: 46%;
    }
</style>
<style>
    #evectiob_travel #travelSavePlanPs .el-textarea__inner{
        height: 400px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/calendar/components/travel.vue